import { CreateStageRequestCloudProviderEnum, CreateStageRequestInfrastructureAsCodeToolEnum } from "@microtica/ms-engine-sdk";
import { Modal, Form, Row, Col, Input, notification } from "antd";
import { RequiredMark } from "antd/lib/form/Form";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { getEnvironmentService } from "../../backend";
import { trackEnvCreateSucceeded, trackEnvCreateFailed } from "../../backend/tracking/environment";
import { currentProjectState } from "../../recoil/project";

interface CreateEnvironmentModalProps {
    visible?: boolean;
    onOk: () => void;
    onCancel: () => void;
}

const CreateEnvironmentModal = ({
    visible,
    onOk,
    onCancel
}: CreateEnvironmentModalProps) => {
    const [form] = Form.useForm();
    const currentProject = useRecoilValue(currentProjectState);
    const [requiredMark] = useState<RequiredMark>('optional');
    const [creatingEnv, setCreatingEnv] = useState(false);

    const handleCreateEnvironment = async (values: { name: string, description: string }) => {
        try {
            console.log("handle")
            setCreatingEnv(true);
            const { data: { id } } = await getEnvironmentService().createStage(
                currentProject!.id,
                {
                    name: values.name,
                    description: values.description,
                    cloudProvider: CreateStageRequestCloudProviderEnum.Aws,
                    infrastructureAsCodeTool: CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation
                });

            // from parent
            await onOk();

            notification.success({ message: "New environment created" });
            trackEnvCreateSucceeded(
                id,
                values.name,
                CreateStageRequestCloudProviderEnum.Aws,
                CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation,
                false
            );
        } catch (error: any) {
            notification.error({
                message: "Cannot create new environment",
                description: error.response.data.message
            });
            trackEnvCreateFailed(
                values.name,
                CreateStageRequestCloudProviderEnum.Aws,
                CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation,
                false,
                error.response.data.message
            );
        } finally {
            setCreatingEnv(false);
        }
    }

    return (
        <Modal
            title="Create new environment"
            visible={visible}
            okText="Create"
            onOk={() => form.submit()}
            confirmLoading={creatingEnv}
            onCancel={() => onCancel()}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{}}
                onFinish={handleCreateEnvironment}
                requiredMark={requiredMark}
            >
                <Row gutter={12}>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="Name"
                            required
                            rules={[{ required: true, message: "Please input environment name" }]}
                        >
                            <Input placeholder="development" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="description"
                            label="Description"
                            required
                            rules={[{ required: true, message: "Please input environment description" }]}
                        >
                            <Input placeholder="My dev env" maxLength={100} showCount />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default CreateEnvironmentModal;
